import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { navigate } from "gatsby";

export default function Index() {
  const portalUserId = useSelector((s) => s.auth.user.portalUserId);

  useEffect(() => {
    if (portalUserId) {
      navigate("/rides");
    } else {
      navigate("/login");
    }
  }, [portalUserId]);

  return null;
}
